import type React from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Foldout, { type IFoldoutItem } from '../Foldout';
import { IconKebab } from '../Icon';
import IconButton from '../IconButtonV2';
import { SrOnly } from '../SrOnly';
import { Wrapper } from './wrapper';

export interface IIconButtonFoldout {
  items: IFoldoutItem[][];
  title?: string;
  openTop?: boolean;
  openRightMd?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  disableTab?: boolean;
  style?: 'overlay';
  children?: React.ReactNode;
}

const IconButtonFoldout = ({
  items,
  title,
  openRightMd,
  openTop,
  disabled,
  disableTab,
  children,
}: IIconButtonFoldout) => {
  const { t } = useTranslation('common');

  const [foldout, setFoldout] = useState(false);
  const onToggleFoldout = useCallback(() => {
    setFoldout(!foldout);
  }, [foldout]);

  return (
    <Wrapper>
      <Foldout
        isOpen={foldout}
        onClose={onToggleFoldout}
        items={items}
        posX="end"
        posXMd={openRightMd ? 'start' : 'end'}
        posY={openTop ? 'top' : undefined}
      >
        <IconButton
          onClick={onToggleFoldout}
          title={
            foldout
              ? t('closeOptions', { ns: 'common' }) || ''
              : title
                ? title
                : t('showOptions', { ns: 'common' }) || ''
          }
          disabled={disabled}
          tabIndex={disableTab ? -1 : undefined}
        >
          <SrOnly as="span">
            {foldout
              ? t('closeOptions', { ns: 'common' }) || ''
              : title
                ? title
                : t('showOptions', { ns: 'common' }) || ''}
          </SrOnly>

          {children ? <span>{children}</span> : <IconKebab />}
        </IconButton>
      </Foldout>
    </Wrapper>
  );
};

export default IconButtonFoldout;
